import { useState } from 'react';
import { setAlert } from '../../../redux/actions';
import { useDispatch } from 'react-redux';

const FollowerSubIndex = () => {
    const dispatch = useDispatch();

    const [puId, setPuId] = useState('');
    const [busy, setBusy] = useState(false);

    const handleSubmit = () => {
        setBusy(true);
        axios.post('/api/administration/follower-sub-index', {
            pu_id: puId
        })
            .then(response => {
                setBusy(false);
                dispatch(setAlert({
                    type: 'success',
                    show: true,
                    body: 'Subscriber indexing completed'
                }));
            })
            .catch(error => {
                setBusy(false);
                dispatch(setAlert({
                    type: 'error',
                    show: true,
                    body: 'Subscriber indexing failed'
                }));
            });
    };
    return <div className='d-flex'>
        <div className='mr-2'>PU ID</div>
        <div className='mr-2'>
            <input
                type="text"
                id="puId"
                value={puId}
                onChange={e => setPuId(e.target.value)}
            />
        </div>
        <div className='mr-2'>
            <button
                type="button"
                className='btn btn-sm btn-primary btn-rounded'
                disabled={busy || puId.length <= 0}
                onClick={handleSubmit}
            >
                {
                    busy ? 'Processing...' : 'Submit'
                }
            </button>
        </div>
    </div>;
};

export default FollowerSubIndex;